// extracted by extract-css-chunks-webpack-plugin
module.exports = {"why":"why___Lm0db","why-header":"why-header___BF_la","reasons":"reasons___CsoCV","reason":"reason___V_zRo"};